export default {
  resmy_orders: "طلباتي",
  resorders_subtitle: "عرض وإدارة جميع طلبات المطعم",

  resshow_normal_orders: "عرض الطلبات العادية",
  resshow_recurring_orders: "عرض الطلبات المتكررة",

  ressearch_order: "ابحث برقم الطلب",
  resall_status: "كل الحالات",
  resplaced: "تم الطلب",
  resconfirmed: "تم التأكيد",
  resout_for_delivery: "قيد التوصيل",
  resdelivered: "تم التوصيل",
  resrejected: "مرفوض",

  resorders_found: "طلبات",

  resdate: "التاريخ",
  resproducts: "المنتجات",
  restotal: "الإجمالي",
  resdaily: "يومي",
  resaction: "إجراء",

  resno_orders: "لا توجد طلبات",

  resmake_daily: "اجعلها يومية",
  respause: "إيقاف",
  resview: "عرض",
  resmodify: "تعديل",
  rescancel: "إلغاء",

  resrecurring_setup: "إعداد الطلب المتكرر",
  resfrequency: "التكرار",
  resweekly: "أسبوعي",
  resselect_days: "اختر الأيام",
  resstart_date: "تاريخ البداية",
  resend_date: "تاريخ النهاية",
  resactivate: "تفعيل",
  resplaced: "تم الطلب",
  resaccepted: "تم القبول",
  respacked: "تم التجهيز",
  resout_for_delivery: "قيد التوصيل",
  resdelivered: "تم التوصيل",
  resrejected: "مرفوض",

  resmore: "المزيد",
  resconfirm_cancel_order: "هل أنت متأكد من إلغاء هذا الطلب؟",
  rescancel_success: "تم إلغاء الطلب بنجاح",
  respause_confirm: "هل تريد إيقاف الطلب المتكرر؟",
  respause_success: "تم إيقاف الطلب المتكرر",
  resrecurring_activated: "تم التفعيل بنجاح 🔥",
  ressomething_wrong: "حدث خطأ ما",

  resrepeat_daily_from: "سيتم تكرار هذا الطلب يومياً بدءاً من",
  resrepeat_weekly_on: "سيتم تكرار هذا الطلب في",

  monday: "الإثنين",
  tuesday: "الثلاثاء",
  wednesday: "الأربعاء",
  thursday: "الخميس",
  friday: "الجمعة",
  saturday: "السبت",
  sunday: "الأحد",
  ressupplier_delivery: "توصيل المورد",

  ressingle_delivery: "تسليم واحد",
  ressplit_deliveries: "عمليات تسليم",

  resview_btn: "عرض ▼",
  reshide_btn: "إخفاء ▲",

  resmonday: "الاثنين",
  restuesday: "الثلاثاء",
  reswednesday: "الأربعاء",
  resthursday: "الخميس",
  resfriday: "الجمعة",
  ressaturday: "السبت",
  ressunday: "الأحد",
resview_expand: "عرض ▼",
reshide_expand: "إخفاء ▲",
last7days: "آخر 7 أيام",
last30days: "آخر 30 يومًا",
last3months: "آخر 3 أشهر",
all: "الكل",

ressearch_order_supplier:
  "ابحث برقم الطلب أو المرجع أو المورد...",

};